export const API_BASE_URL =
  import.meta.env.VITE_API_URL || 'https://staging-api25.become-hub.com';

export const AUTH_STORE_NAME = 'auth-store';

// Store names for localStorage
export const STORE_NAMES = {
  AUTH: 'auth-store',
  SESSION: 'session-store',
  HEART_RATE: 'heartRate-store',
} as const;

export const DEVICE_STATUS = {
  DISCONNECTED: 'disconnected',
  CONNECTED_NO_DATA: 'connected_no_data',
  CONNECTED: 'connected',
  RECEIVING_DATA: 'receiving_data',
};

export const RECEIVING_MS = 30_000;
export const DATA_TIMEOUT_MS = 120_000;
export const DEVICE_IDLE_MS = 60_000;
export const SENSOR_IDLE_MS = 10_000;

export const BASELINE_DURATION = 5;

// Cloudinary configuration
export const CLOUDINARY_CLOUD_NAME = 'dkucaw60h';
export const CLOUDINARY_BASE_URL = `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload`;

// Product icons mapping (Cloudinary public IDs)
export const PRODUCT_ICONS = {
  exposure: 'exposure_c0abnq',
  body_image: 'exposure_c0abnq',
  psychology: 'psychology_pdxyc5',
  corporate: 'corporate_t8dgxl',
  situations: 'situations_ljsti0',
  wellbeing: 'wellbeing_enrev4',
  performance: 'performance_bkd7zo',
  mentalization: 'mentalization_fkvfin',
} as const;

// Helper function to get product icon URL
export const getProductIconUrl = (
  productType: keyof typeof PRODUCT_ICONS
): string => {
  return `${CLOUDINARY_BASE_URL}/${PRODUCT_ICONS[productType]}`;
};
